import Button from "antd/lib/button";
import Popover from "antd/lib/popover";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { trpc } from "@utils/trpc";

const UpdateWalletAction = ({
    disabledText,
    disabled,
    isLoading,
    handleUpdate,
}: {
    disabledText: string;
    isLoading?: boolean;
    disabled?: boolean;
    handleUpdate: () => void;
}) => {
    const { data: processingFrozen } = trpc.team.isProcessingFrozen.useQuery();
    if (disabled) {
        return (
            <Popover content={disabledText}>
                <Button
                    type="text"
                    disabled
                    className="group"
                    icon={
                        <RefreshRoundedIcon className="animate-spin text-text-disabled" />
                    }
                />
            </Popover>
        );
    }

    return (
        <Popover content="Update Transactions">
            <Button
                onClick={() => handleUpdate()}
                type="text"
                disabled={isLoading || processingFrozen}
                className="group"
                icon={
                    <RefreshRoundedIcon
                        className={`text-text-icon duration-100 ${
                            isLoading ? "animate-spin" : ""
                        }`}
                    />
                }
            />
        </Popover>
    );
};

export default UpdateWalletAction;
